import React, { createContext, ReactElement, useContext, useReducer } from 'react';
import DashboardSettings from 'domain/entity/settings';

export enum ACTION_TYPE {
    SET_SETTINGS = 'SET_SETTINGS',
}

export const initialState = {
    settings: new DashboardSettings([]),
};

type SetSettings = {
    type: ACTION_TYPE.SET_SETTINGS;
    payload: DashboardSettings;
};

export type SettingsViewStateType = {
    settings: DashboardSettings;
};

export type SettingsViewDispatchType = {
    setSettings: (settings: DashboardSettings) => void;
};

type SettingsViewActionType = SetSettings;
export const useCaseSettingsViewReducer = (
    state: SettingsViewStateType,
    action: SettingsViewActionType
    // eslint-disable-next-line consistent-return
): SettingsViewStateType => {
    const { type, payload } = action;
    // eslint-disable-next-line default-case
    switch (type) {
        case ACTION_TYPE.SET_SETTINGS: {
            return {
                ...state,
                settings: payload as DashboardSettings,
            };
        }
    }
};

type SettingsProviderProps = {
    children: ReactElement;
};

export const SettingsViewDispatchContext = createContext({} as SettingsViewDispatchType);
export const SettingsViewStateContext = createContext({} as SettingsViewStateType);

export const dispatchSettingsView = (): SettingsViewDispatchType => useContext(SettingsViewDispatchContext);
export const useSettingsView = (): SettingsViewStateType => useContext(SettingsViewStateContext);

export const SettingsViewProvider = (props: SettingsProviderProps): ReactElement => {
    const { children } = props;
    const [state, dispatch] = useReducer(useCaseSettingsViewReducer, initialState);

    const setSettings = (settings: DashboardSettings) =>
        dispatch({
            type: ACTION_TYPE.SET_SETTINGS,
            payload: settings,
        });

    return (
        <SettingsViewStateContext.Provider value={state}>
            <SettingsViewDispatchContext.Provider value={{ setSettings }}>{children}</SettingsViewDispatchContext.Provider>
        </SettingsViewStateContext.Provider>
    );
};
